import axios, { AxiosResponse, InternalAxiosRequestConfig } from 'axios'
import { Store } from './utils/toast'
import { getAppType, getStorageKey } from './utils/appType'

export const serverUrl = ['127.0.0.1', 'localhost'].includes(
  window.location.hostname,
)
  ? 'http://localhost:8000'
  : ''

const baseURL = `${serverUrl}/api`

const axiosRequest = axios.create({
  baseURL,
  timeout: 5 * 60 * 1000,
})

axiosRequest.interceptors.request.use((config: InternalAxiosRequestConfig) => {
  const token = localStorage.getItem(getStorageKey('token'))
  const isAuthEndpoint = config.url?.startsWith('/auth')

  config.baseURL = isAuthEndpoint
    ? `${serverUrl}/api`
    : `${serverUrl}/api/${getAppType()}`

  if (token) {
    config.headers.set('Authorization', `Bearer ${token}`)
  }

  return config
})

axiosRequest.interceptors.response.use(
  (response: AxiosResponse): AxiosResponse => {
    return response
  },
  (error: unknown) => {
    if (axios.isAxiosError(error) && error.response?.status === 401) {
      const loginPath = `/${getAppType()}/login`

      Store.addNotification({
        title: 'ERROR',
        message: 'a expirat sesiunea',
        container: 'top-center',
        type: 'danger',
        insert: 'top',
        animationIn: ['animate__animated', 'animate__fadeIn'],
        animationOut: ['animate__animated', 'animate__fadeOut'],
        dismiss: {
          duration: 1000,
          onScreen: true,
        },
      })

      localStorage.removeItem(getStorageKey('token'))

      if (window.location.pathname !== loginPath) {
        window.location.replace(loginPath)
      }
    }

    if (axios.isAxiosError(error) && error.response?.status === 400) {
      return Promise.reject(error)
    }

    return Promise.reject(error)
  },
)

export const request = axiosRequest
